interface FilterGroupProps {
  title: string;
  options: string[];
  value: string;
  allLabel?: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({
  title,
  options,
  value,
  allLabel = "全部",
  onChange,
}: FilterGroupProps) {
  const items = [allLabel, ...options];
  return (
    <div>
      <h3 className="text-xs font-medium text-foreground-400 mb-3 tracking-wide">
        {title}
      </h3>
      <div className="flex flex-wrap gap-2">
        {items.map((option) => {
          const active = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-600 text-background-50 font-medium"
                  : "bg-background-900 border border-background-800 text-foreground-300 hover:border-primary-600 hover:text-accent-400"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}